import classNames from "classnames";
import { useEffect, useState, useCallback } from "react";
import { DEPLOY_STATUSES } from "../../../constants";

const ZERO = 0;
const circumference = 20 * 2 * Math.PI;
const { SUCCESS, FAILURE, CANCELLED } = DEPLOY_STATUSES;

const ProgressBar = ({
  logs,
  stepsStatus,
  barType,
  progress,
  progressStatus,
}) => {
  const [percentage, setPercentage] = useState(ZERO);
  const [isBlocked, setIsBlocked] = useState(false);
  const [width, setWidth] = useState(ZERO);
  useEffect(() => {
    if (stepsStatus)
      setIsBlocked(
        stepsStatus.some(
          (step) => step.status === FAILURE || step.status === CANCELLED
        )
      );
  }, [stepsStatus]);

  const calculateOverallProgress = useCallback((logs) => {
    const totalSections = Object.keys(logs).filter(
      (log) => log !== "deployedAt"
    )?.length;
    const currentProgress = Object.values(logs)
      .filter((log) => log.status)
      .reduce((progress, currentStep) => {
        if (currentStep.status === SUCCESS)
          return progress + (1 / totalSections) * 100;
        else {
          const totalsubSteps = currentStep?.steps?.length;
          if (!totalsubSteps) return progress;
          const completedSubSteps = currentStep?.steps?.filter(
            (step) => step?.conclusion === SUCCESS
          ).length;
          return (
            progress +
            ((completedSubSteps / totalsubSteps) * 100) / totalSections
          );
        }
      }, ZERO);
    return currentProgress;
  }, []);

  useEffect(() => {
    if (logs) {
      const overallProgress = calculateOverallProgress(logs);
      setPercentage(Math.floor(overallProgress));
    }
  }, [logs, calculateOverallProgress]);

  useEffect(() => {
    if (!percentage && isBlocked) setWidth(100);
    else setWidth(percentage);
  }, [percentage, isBlocked]);
  return (
    <div className={classNames()}>
      {barType === "line" && (
        <div
          className={classNames("flex overflow-hidden rounded bg-gray-200", {
            "shim-blue": width === ZERO && !progressStatus,
          })}
        >
          <div
            className={classNames("h-3 rounded-lg text-right", {
              "bg-red-500 flex progress-bar-striped":
                isBlocked || progressStatus === "rejected",
              "transition ease bg-green-500 flex progress-bar-striped ":
                !isBlocked,
              "progress-bar-animated":
                width !== 100 &&
                progress !== 100 &&
                !isBlocked &&
                !progressStatus === "rejected",
            })}
            style={{ width: `${progress || width}%` }}
          ></div>
        </div>
      )}
      {barType === "circle" && (
        <div
          className={classNames(
            "inline-flex items-center justify-center overflow-hidden rounded-full ",
            {
              "shim-blue": width === ZERO,
            }
          )}
        >
          <svg className="w-10 h-10">
            <circle
              className="text-white"
              strokeWidth="5"
              stroke="currentColor"
              fill="transparent"
              r="20"
              cx="20"
              cy="20"
            />
            <circle
              className={classNames({
                "text-green-600": !isBlocked,
                "text-red-600": isBlocked,
              })}
              strokeDasharray={circumference}
              strokeDashoffset={circumference - (width / 100) * circumference}
              strokeLinecap="round"
              strokeWidth="5"
              stroke="currentColor"
              fill="transparent"
              r="20"
              cx="20"
              cy="20"
            />
          </svg>{" "}
          <span className=" absolute text-xs text-white ">{`${percentage}%`}</span>
        </div>
      )}
    </div>
  );
};

export default ProgressBar;
